export const data = {
  nav: {
    logo: "ikb tech",
    navList: ["Leistungen", "Kunden", "Schwerpunkte", "Karriere"],
    contact: {
      contactIcon: "/assets/icons/contact.svg",
    },
    menuIcon: "/assets/icons/menu.svg",
    closeIcon: "/assets/icons/close.svg",
  },
  sectionMain: {
    img: "/assets/images/thisisengineering-raeng-3Z3gnA99PL8-unsplash.jpg",
    attr: "thisisengineering-raeng-3Z3gnA99PL8-unsplash",
    headline1: "Maschinenbau",
    headline2: "Auf dem höchsten Niveau",
    suppLine: "Sowie Anlagenbau, Flugzeugbau und Vorrichtungsbau",
  },
  sectionLeistungen: {
    quote:
      "“IKB-TECH ist eine innovative Ingenieurdienstleistungsgesellschaft und ein zuverlässiger Partner im High-Tech-Umfeld mit Kundschaft aus verschiedenen Branchen der Großindustrie und dem Mittelstand.”",
    category: "Leistungen",
    headline: "Von der Idee zum Produkt",
    text:
      "Unser Team bietet in enger Absprache mit unseren Kunden vielseitige Leistungen, die alle Prozessschritte begleiten - von der innovativen Idee bis hin zum fertigen Produkt.",
    services: [
      {
        title: "Marktforschung",
        icon: "/assets/icons/leistungen/paid-search.png",
      },
      {
        title: "Marktanalyse",
        icon: "/assets/icons/leistungen/statistics.png",
      },
      {
        title: "Vermarktung",
        icon: "/assets/icons/leistungen/sellsy.png",
      },
      {
        title: "Konzepterstellung",
        icon: "/assets/icons/leistungen/imac-settings.png",
      },
      {
        title: "Projektplanung",
        icon: "/assets/icons/leistungen/construction-carpenter-ruler.png",
      },
      {
        title: "Entwicklung",
        icon: "/assets/icons/leistungen/project-management.png",
      },
      {
        title: "Konstruktion",
        icon: "/assets/icons/leistungen/room-finder.png",
      },
      {
        title: "Simulation",
        icon: "/assets/icons/leistungen/solidworks-flow-simulation.png",
      },
      {
        title: "Berechnung",
        icon: "/assets/icons/leistungen/sun-elevation.png",
      },
      {
        title: "Dokumentation",
        icon: "/assets/icons/leistungen/course-assign.png",
      },
      {
        title: "Prototypenbau",
        icon: "/assets/icons/leistungen/3d-printer.png",
      },
      {
        title:"Serienbetreung",
        icon: "/assets/icons/leistungen/3d-printer.png",
      },
    ],
    proposal: "",
    linkId: "",
  },
  sectionKunden: {
    quote:
      "",
    category: "Referenzen",
    headline: "Weitere Kunde die uns vertrauen",
    text:
    "Kundenzufriedenheit steht auf dem Ersten Platz in unserer Unternehmensphilosophie und bildet die Basis für eine langfristige und erfolgreiche Zusammenarbeit mit unseren Kunden.",
    kundenLogos: [
      {
        title: "maserati",
        logo: "/assets/logos/kunden/maserati-logo.svg",
      },
      {
        title: "cpm",
        logo: "/assets/logos/kunden/cpm-logo.svg",
      },
      {
        title: "audi",
        logo: "/assets/logos/kunden/audi-logo.svg",
      },
      {
        title: "volkswagen",
        logo: "/assets/logos/kunden/volkswagen-logo.svg",
      },
      {
        title: "zf",
        logo: "/assets/logos/kunden/zf-logo.png",
      },
      {
        title: "general-motors",
        logo: "/assets/logos/kunden/general-motors-logo.png",
      },
      {
        title: "nordex",
        logo: "/assets/logos/kunden/nordex-logo.svg",
      },
      {
        title: "porsche",
        logo: "/assets/logos/kunden/porsche-logo.svg",
      },
      {
        title: "bmw",
        logo: "/assets/logos/kunden/bmw-logo.svg",
      },
      {
        title: "LSP",
        logo: "/assets/logos/kunden/lsp-logo.jpg",
      },
      {
        title: "Silver Atena",
        logo: "/assets/logos/kunden/silver-atena-logo.png",
      },
      {
        title: "Volvo",
        logo: "/assets/logos/kunden/volvo-logo.svg",
      },
    ],
    proposal: "",
    linkId: "",
  },
  sectionSchwerpunkte: {
    quote: "AUSFÜLLEN",
    schwerpunkteList: [
      {
        img: "/assets/images/mike-hindle-urTBnMtWWYc-unsplash.jpg",
        attr: "mike-hindle-urTBnMtWWYc-unsplash",
        services: [
          "Allgemeiner",
          "Maschinenbau",
          "Sondermaschinen",
          "Betriebsmittelbau",
        ],
      },
      {
        img: "/assets/images/artur-voznenko-lPvI0S403Mg-unsplash.jpg",
        attr: "artur-voznenko-lPvI0S403Mg-unsplash",
        services: ["Flugzeugbau","Aerobus"],
      },
      {
        img: "/assets/images/logan-weaver-lgnwvr-u4vvzLElyF0-unsplash.jpg",
        attr: "logan-weaver-lgnwvr-u4vvzLElyF0-unsplash",
        services: [
          "Automobilbau",
          "Sonderfahrzeugbau",
          "Schienentechnik",
          "Nutzfahrzeugtechnik",
        ],
      },
      {
        img: "/assets/images/mika-baumeister-ufEolQ65luE-unsplash.jpg",
        attr: "mika-baumeister-ufEolQ65luE-unsplash",
        services: ["Radfahrzeuge", "Kettenfahrzeuge", "KMW"],
      },
      {
        img: "/assets/images/cesar-carlevarino-aragon-NL_DF0Klepc-unsplash.jpg",
        attr: "cesar-carlevarino-aragon-NL_DF0Klepc-unsplash",
        services: ["Formenbau", "Werkzeugbau", "Vorrichtungsbau"],
      },
      {
        img: "/assets/images/vladislav-glukhotko-RBwk0EcQ1bs-unsplash.jpg",
        attr: "vladislav-glukhotko-RBwk0EcQ1bs-unsplash",
        services: ["Stahlbau", "Anlagenbau"],
      },
      {
        img: "/assets/images/rob-lambert-9Q_pLLP_jmA-unsplash.jpg",
        attr: "rob-lambert-9Q_pLLP_jmA-unsplash",
        services: ["Lötten", "Schweissen"],
      },
      {
        img: "/assets/images/crystal-kwok-xD5SWy7hMbw-unsplash.jpg",
        attr: "crystal-kwok-xD5SWy7hMbw-unsplash",
        services: ["Messsysteme", "Prüfsysteme", "Kontrollsysteme"],
      },
    ],
    proposal: "",
    linkId: "",
  },
  sectionProgrammen: {
    quote:
      "“Die mehrjährigen Erfahrungen unsere Mitarbeiter im Bereich Ingenieurwesen mit modernen CAD-Programmen und leistungsfähige Software-Tools bilden die Grundlage für unsere innovativen Entwicklungs- und Konstruktionsprozesse.”",
    category: "Programmen",
    headline: "Wir arbeiten mit moderne CAD Software",
    text: [
      "PTC Creo 6, 7, 8, 9",
      "CATIA V4/V5",
      "SolidWorks",
      "Solid Edge",
      "AutoCAD",
    ],
    programmsLogos: [
      {
        logo: "/assets/logos/soft/catia.svg",
        attr: "catia-logo",
      },
      {
        logo: "/assets/logos/soft/ptc-creo.svg",
        attr: "ptc-creo-logo",
      },
      {
        logo: "/assets/logos/soft/solidworks.png",
        attr: "solidworks",
      },
      {
        logo: "/assets/logos/soft/solid-edge.png",
        attr: "solid-edge",
      },
      {
        logo: "/assets/logos/soft/autocad.svg",
        attr: "autocad-logo",
      },
    ],
    proposal: "",
    linkId: "",
  },
  zahlen: [
    {
      main: "100+",
      category: "Kunden",
      description: "aus unterschiedliche Branchen",
    },
    {
      main: "22+",
      category: "Jahre",
      description: "aus unterschiedliche Branchen",
    },
    {
      main: "15+",
      category: "Mitarbeiter",
      description: "aus unterschiedliche Branchen",
    },
    {
      main: "200+",
      category: "Projekte",
      description: "aus unterschiedliche Branchen",
    },
  ],
  sectionKontakt: {
    quote: "“Wir würden uns freuen Sie von den Vorteilen der IKB TECH zu überzeugen und freuen uns von Ihnen zu hören. Wenn Sie als Bewerber, Zulieferer oder Neukunde an einer Zusammenarbeit interessiert sind, nehmen Sie bitte Kontakt mit uns auf.”",
    category: "Kontakt",
    headline:
      "Für Ihre Fragen stehen wir Ihnen gern zur Verfügung.",
    contactTypes: [
      {
        icon: "/assets/icons/phone.png",
        attr: "phone",
        text: "(+49)01629334162",
      },
      {
        icon: "/assets/icons/email.png",
        attr: "email",
        text: "ikb.kappes@gmail.com",
      },
      {
        icon: "/assets/icons/post.png",
        attr: "post",
        text: "Angerlohstr. 55, 80997 München",
      },
    ],
    img: {
      src: "/assets/images/marissa-grootes-xhb7s-Q-ECA-unsplash.jpg",
      alt: "marissa-grootes-xhb7s-Q-ECA-unsplash",
    },
  },
  sectionKarriere: {
    quote:
      "“Unseren Mitarbeitern bieten wir eine Unternehmenskultur die nicht einengt. Bei uns finden Sie Raum zur Entfaltung von unterschiedlichen Charakteren.”",
    img: {
      src: "/assets/images/thisisengineering-raeng-aL2rxQhEfAM-unsplash.jpg",
      alt: "thisisengineering-raeng-aL2rxQhEfAM-unsplash",
    },
    category: "Karriere",
    headline: "Gemeinsam gestalten die Zukunft ",
    text:
      "Die IKB-TECH Ingenieurgesellschaft bietet Ihnen die Möglichkeit, Ihre Erfahrungen und Ideen einzubringen und weiterzuentfalten. Wir ermöglichen jungen Talenten den Berufseinstieg mit einer individuellen Einarbeitung.",
    proposal: "Bewerben Sie sich",
    linkId: "kontakt",
  },
  sectionFooter: {
    blocksInformation: [
      {
        headline: "Adresse",
        elList: [
          {
            icon: "/assets/icons/address.png",
            alt: "address-icon",
            text: "IKB-TECH Angerlohstr. 55 80997 München",
          },
        ],
      },
      {
        headline: "Telefonnummer",
        elList: [
          {
            icon: "/assets/icons/phone.png",
            alt: "phone-icon",
            text: "01629334162",
          },
        ],
      },
      {
        headline: "Email",
        elList: [
          {
            icon: "/assets/icons/email.png",
            alt: "email-icon",
            text: "ikb.kappes@gmail.com",
          },
        ],
      },
      {
        headline: "Rechtsinformation",
        elList: [
          {
            icon: "/assets/icons/section.png",
            alt: "impressum",
            text: "Impressum",
            link: "/impressum",
          },
          {
            icon: "/assets/icons/section.png",
            alt: "datenschutz",
            text: "Datenschutz",
            link: "/datenschutz",
          },
          {
            icon: "/assets/icons/section.png",
            alt: "bilder-lizenz",
            text: "Bilder Lizenz",
            link: "/bilder-lizenz",
          },
        ],
      },
    ],
    copyright: "© 2024 IKB-TECH  ALLE RECHTE VORBEHALTEN",
  },
};

export const imagesList = [
  {
    src: "/assets/images/thisisengineering-raeng-3Z3gnA99PL8-unsplash.jpg",
    alt: "thisisengineering-raeng-3Z3gnA99PL8-unsplash",
    author: "ThisisEngineering RAEng",
    authorLink:
      "https://unsplash.com/fr/@thisisengineering?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink:
      "https://unsplash.com/photos/3Z3gnA99PL8?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/marissa-grootes-xhb7s-Q-ECA-unsplash.jpg",
    alt: "marissa-grootes-xhb7s-Q-ECA-unsplash",
    author: "Marissa Grootes",
    authorLink:
      "https://unsplash.com/@stilclassis?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink:
      "https://unsplash.com/photos/xhb7s-Q-ECA?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/thisisengineering-raeng-aL2rxQhEfAM-unsplash.jpg",
    alt: "thisisengineering-raeng-aL2rxQhEfAM-unsplash",
    author: "ThisisEngineering RAEng",
    authorLink:
      "https://unsplash.com/@thisisengineering?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink:
      "https://unsplash.com/photos/aL2rxQhEfAM?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/mike-hindle-urTBnMtWWYc-unsplash.jpg",
    alt: "mike-hindle-urTBnMtWWYc-unsplash",
    author: "Mike Hindle",
    authorLink: "https://unsplash.com/@mikehindle?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/urTBnMtWWYc?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },  
  {
    src: "/assets/images/artur-voznenko-lPvI0S403Mg-unsplash.jpg",
    alt: "artur-voznenko-lPvI0S403Mg-unsplash",
    author: "Artur Voznenko",
    authorLink: "https://unsplash.com/@voznenko_artur?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/lPvI0S403Mg?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/logan-weaver-lgnwvr-u4vvzLElyF0-unsplash.jpg",
    alt: "logan-weaver-lgnwvr-u4vvzLElyF0-unsplash",
    author: "LOGAN WEAVER | @LGNWVR",
    authorLink: "https://unsplash.com/@lgnwvr?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/u4vvzLElyF0?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/mika-baumeister-ufEolQ65luE-unsplash.jpg",
    alt: "mika-baumeister-ufEolQ65luE-unsplash",
    author: "Mika Baumeister",
    authorLink: "https://unsplash.com/@mbaumi?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/ufEolQ65luE?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/rob-lambert-9Q_pLLP_jmA-unsplash.jpg",
    alt: "",
    author: "Rob Lambert",
    authorLink: "https://unsplash.com/@roblambertjr?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/9Q_pLLP_jmA?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/crystal-kwok-xD5SWy7hMbw-unsplash.jpg",
    alt: "crystal-kwok-xD5SWy7hMbw-unsplash",
    author: "Crystal Kwok",
    authorLink: "https://unsplash.com/@spacexuan?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/xD5SWy7hMbw?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/cesar-carlevarino-aragon-NL_DF0Klepc-unsplash.jpg",
    alt: "cesar-carlevarino-aragon-NL_DF0Klepc-unsplash",
    author: "Cesar Carlevarino Aragon",
    authorLink: "https://unsplash.com/@carlevarino?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/NL_DF0Klepc?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
  {
    src: "/assets/images/vladislav-glukhotko-RBwk0EcQ1bs-unsplash.jpg",
    alt: "vladislav-glukhotko-RBwk0EcQ1bs-unsplash",
    author: "Vladislav Glukhotko",
    authorLink: "https://unsplash.com/@azzurobudgie?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
    imageLink: "https://unsplash.com/photos/RBwk0EcQ1bs?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText",
  },
];
